import { render, staticRenderFns } from "./InformacionGeneralConfiguracion.vue?vue&type=template&id=1d4a9ae7&"
import script from "./InformacionGeneralConfiguracion.vue?vue&type=script&lang=js&"
export * from "./InformacionGeneralConfiguracion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VSimpleTable,VTextField})
